export default "__VITE_ASSET__BZGKzMUv__"